import { render, staticRenderFns } from "./NsGroup.vue?vue&type=template&id=3407c44e"
import script from "./NsGroup.vue?vue&type=script&lang=js"
export * from "./NsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports